import { useLocation } from "react-router-dom";
import { settingsNavPathV3 } from "@/react/helpers/urlHelpers";
import { useGetEmailHubStatus } from "@/react/hooks/useGetEmailHubStatus";
import { useIsWorkflowExecutionEnabled } from "@circle-react-shared/Workflows/hooks/useIsWorkflowExecutionEnabled";
import { useWorkflowsData } from "../context/WorkflowsDataProvider";
import { useTotalWorkflowsCount } from "./useTotalWorkflowsCount";

export const useWorkflowsSplashScreen = () => {
  const { pathname } = useLocation();

  const isWorkflowExecutionEnabled = useIsWorkflowExecutionEnabled();
  const { data: emailHubStatusData, isLoading: isLoadingEmailHubStatus } =
    useGetEmailHubStatus();
  const { category } = useWorkflowsData();
  const {
    data: { total_count: totalWorkflows } = {},
    isLoading: isLoadingTotalCount,
  } = useTotalWorkflowsCount();

  const isLoading = isLoadingEmailHubStatus || isLoadingTotalCount;

  // Only show splash screen on the exact workflows index route, not sub-routes
  const isExactWorkflowsIndexRoute =
    pathname === settingsNavPathV3.workflows.all;

  const shouldShowWorkflowsSplashScreen =
    !isLoading &&
    isExactWorkflowsIndexRoute &&
    (totalWorkflows === 0 ||
      (!isWorkflowExecutionEnabled && !emailHubStatusData?.enabled)) &&
    !category;

  const shouldHideWorkflowsNestedNavigation =
    isExactWorkflowsIndexRoute && shouldShowWorkflowsSplashScreen;

  return {
    isLoading,
    shouldShowWorkflowsSplashScreen,
    shouldHideWorkflowsNestedNavigation,
  };
};
